import { toast } from "react-toastify";
import { useImpersonation } from "../../../store/impersonation/useImpersonation";
import {
  getSessionHomePath,
  restoreOriginalSession,
  startImpersonationSession,
} from "../../auth";

const getItemId = (item) => item?.id || item?._id || item?.storeId || item?.employeeId || item?.userId;

export class ImpersonationController {
  constructor(props) {
    this.model = props.models.impersonation;
    this.actions = useImpersonation.getState().actions;
  }

  open = async () => {
    this.actions.setOpen(true);
    await this.loadStores();
  };

  close = () => this.actions.setOpen(false);

  loadStores = async () => {
    this.actions.setLoading(true);
    const stores = await this.model.getStores();
    if (stores) this.actions.setStores(stores);

    this.actions.setLoading(false);
  };

  selectStore = async (store) => {
    const storeId = getItemId(store);

    this.actions.selectStore(store);

    if (!storeId) return;

    this.actions.setLoading(true);
    const users = await this.model.getUsersByStore(storeId);

    if (users) this.actions.setUsers(users);

    this.actions.setLoading(false);
  };

  setStoreFilter = (value) => this.actions.setStoreFilter(value);

  setUserFilter = (value) => this.actions.setUserFilter(value);

  selectUser = (user) => this.actions.selectUser(user);

  start = async () => {
    const { selectedStore, selectedUser } = useImpersonation.getState().data;
    const storeId = getItemId(selectedStore);
    const userId = getItemId(selectedUser);

    if (!storeId || !userId) {
      toast.error("Selecione uma loja e um usuário para continuar.", { theme: "colored" });
      return;
    }

    this.actions.setStarting(true);
    const data = await this.model.start({ storeId, userId });
    this.actions.setStarting(false);

    if (!data?.token) return;

    startImpersonationSession(data);
    window.location = getSessionHomePath();
  };

  stop = async () => {
    await this.model.stop();

    if (!restoreOriginalSession()) {
      toast.error("Não foi possível restaurar a sessão original. Faça login novamente.", { theme: "colored" });
      window.location = "/";
      return;
    }

    window.location = getSessionHomePath();
  };
}
